import React, { Component, Context } from "react";
import { connect } from "react-redux";
import clsx from "clsx";
import { WidgetProps } from "../widgets";
import { IHonorUState, mapHonorUStateToProps } from "../../redux/reducers/honoru";
import { IHonorUActionDispatches, mapHonorUDispatchToProps, getProfileUrl } from "../../redux/actions/honoru";
import { IHonorUProfile } from "../../models/honoru";
import { getDateDisplay } from "../../utils/date-utils";
import LayoutContext, { ILayoutContext } from "../../contexts/layout/LayoutContext";
import ImageEnlarge from "../ui/Media/ImageEnlarge";
import { getGalleryImageDimensions } from "../../models/layout";
import { FileType } from "../../laco-common/base/models/IFile";

class HonorUProfiles extends Component<IHonorUActionDispatches & IHonorUState & WidgetProps> {
	static contextType: Context<ILayoutContext> = LayoutContext;

	componentDidMount() {
		this.props.loadProfiles();
	}

	render() {
		const imageDimensions = getGalleryImageDimensions(this.context.settings);
		return (
			<LayoutContext.Provider value={{ ...this.context, ...imageDimensions }}>
				<div className="w-100 bg-black position-relative">
					<div
						className={clsx(
							!this.props.isNested && "container",
							!this.props.page?.noPadding && "section-padding",
							"white-side-right1"
						)}
					>
						<h1 className="highlighted text-white mb-5">Our Firefighters </h1>
						<div className="d-flex flex-column flex-md-row justify-content-between">
							{this.props.profiles.map((profile: IHonorUProfile, i: number) => (
								<div key={profile.id} style={{ maxWidth: imageDimensions.imageWidth }} className="mb-5">
									<ImageEnlarge
										image={{
											title: profile.name,
											url: getProfileUrl(profile),
											filename: profile.profileImg,
											fileType: FileType.IMAGE,
											order: i,
											preview: false,
											desc: profile.summary,
										}}
									/>
									<div className="text-gray text-uppercase text-sm mt-4 mb-1">
										{getDateDisplay(profile.from, profile.to, " TO ", true, true)}
									</div>
									<a
										className="text-white"
										href={`https://honoru.co/profile/${profile.id}/`}
										target="_blank"
									>
										<h3 className="subheading">{profile.name}</h3>
										<span className="with-arrow mt-0 text-xs">View Profile</span>
									</a>
								</div>
							))}
						</div>
						<a href="https://honoru.co/" target="_blank" className="d-inline-block w-100 text-center">
							<button className="btn btn-primary py-2 w-100-xs">View All Profiles</button>
						</a>
					</div>
				</div>
			</LayoutContext.Provider>
		);
	}
}

export default connect<IHonorUState, IHonorUActionDispatches, WidgetProps>(
	mapHonorUStateToProps,
	mapHonorUDispatchToProps
)(HonorUProfiles);
